import { motion } from "framer-motion";
import {
    Droplets,
    Search,
    Flame,
    Bath,
    Siren,
    ArrowUpRight,
} from "lucide-react";
import { telHref } from "../lib/business";

const SERVICES = [
    {
        key: "tikaniklik",
        title: "Tıkanıklık Açma",
        desc: "Lavabo, klozet, gider ve ana hat tıkanıklıkları için profesyonel tesisatçı hizmeti. Modern spiral ve robotik ekipman.",
        Icon: Droplets,
        accent: "from-[#0055FF] to-[#3D7BFF]",
        bg: "bg-[#E5EDFF]",
        text: "text-[#0055FF]",
        span: "lg:col-span-2",
    },
    {
        key: "kacak",
        title: "Su Kaçağı Tespiti",
        desc: "Kırma-dökme yok. Su tesisatçısı ekibimiz termal kamera ve akustik dinleme cihazıyla noktasal tespit yapar.",
        Icon: Search,
        accent: "from-[#0EA5E9] to-[#22D3EE]",
        bg: "bg-[#E0F2FE]",
        text: "text-[#0284C7]",
        span: "",
    },
    {
        key: "kombi",
        title: "Kombi & Petek Tamiri",
        desc: "Tüm marka kombiler için uzman tesisatçı: peteklerde sıcaklık düşüklüğü, hava alma, kireç temizliği.",
        Icon: Flame,
        accent: "from-[#F97316] to-[#FB923C]",
        bg: "bg-[#FFEDD5]",
        text: "text-[#EA580C]",
        span: "",
    },
    {
        key: "banyo",
        title: "Banyo & Mutfak Tesisatı",
        desc: "Tadilat, batarya, sifon, gizli rezervuar, tezgah ve evye için profesyonel su tesisatçısı kurulumu.",
        Icon: Bath,
        accent: "from-[#8B5CF6] to-[#A78BFA]",
        bg: "bg-[#EDE9FE]",
        text: "text-[#7C3AED]",
        span: "lg:col-span-2",
    },
    {
        key: "acil",
        title: "7/24 Acil Tesisatçı",
        desc: "Gece-gündüz, hafta sonu, tatil — fark etmez. Acil su tesisatçısı ekibimiz tek aramayla 30 dk içinde kapınızda.",
        Icon: Siren,
        accent: "from-[#FF3B30] to-[#FF6B61]",
        bg: "bg-[#FEE2E2]",
        text: "text-[#DC2626]",
        span: "lg:col-span-3",
        featured: true,
    },
];

export const Services = () => {
    return (
        <section
            id="hizmetler"
            data-testid="services-section"
            className="relative py-20 sm:py-28 bg-[#F8FAFC]"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl mb-12">
                    <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#0055FF]">
                        Tesisatçı Hizmetleri
                    </div>
                    <h2 className="mt-3 font-black tracking-tighter text-slate-900 text-3xl sm:text-4xl lg:text-5xl leading-[1.02]">
                        Kayseri <span className="text-[#0055FF]">su tesisatçısı</span> hizmetlerimiz.
                    </h2>
                    <p className="mt-4 text-base sm:text-lg text-slate-600 max-w-2xl">
                        Kayseri ve çevresinde 7/24 <strong className="text-slate-900">su tesisatçısı</strong> olarak hizmet veriyoruz.
                        İhtiyacınız olan tüm tesisat işleri için uzman <strong className="text-slate-900">tesisatçı</strong> ekibimiz hazır.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                    {SERVICES.map((s, idx) => (
                        <motion.a
                            key={s.key}
                            href={telHref}
                            data-testid={`service-card-${s.key}`}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-50px" }}
                            transition={{ duration: 0.5, delay: idx * 0.08 }}
                            className={`group relative overflow-hidden rounded-2xl border border-slate-200 bg-white p-6 sm:p-7 hover:border-slate-300 hover:shadow-[0_22px_40px_-22px_rgba(15,23,42,0.25)] transition-all ${s.span}`}
                        >
                            {s.featured && (
                                <div className="absolute top-5 right-5 inline-flex items-center gap-1.5 rounded-full bg-[#FF3B30] px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-widest text-white">
                                    <span className="w-1.5 h-1.5 rounded-full bg-white live-dot" />
                                    Acil
                                </div>
                            )}
                            <div className={`inline-flex items-center justify-center w-12 h-12 rounded-xl ${s.bg} transition-transform group-hover:scale-110`}>
                                <s.Icon className={`w-6 h-6 ${s.text}`} strokeWidth={2.5} />
                            </div>
                            <h3 className="mt-5 font-extrabold tracking-tight text-slate-900 text-xl sm:text-2xl">
                                {s.title}
                            </h3>
                            <p className="mt-2 text-slate-600 leading-relaxed text-[15px]">
                                {s.desc}
                            </p>
                            <div className="mt-5 inline-flex items-center gap-1.5 text-sm font-bold text-slate-900 group-hover:text-[#0055FF] transition-colors">
                                Hemen ara
                                <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={2.5} />
                            </div>

                            <div className={`pointer-events-none absolute -bottom-20 -right-20 w-48 h-48 rounded-full bg-gradient-to-br ${s.accent} opacity-0 blur-3xl transition-opacity group-hover:opacity-25`} />
                        </motion.a>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Services;
